import { Typography } from 'antd'

import { titlesOf } from '@/Containers/TransportationSection/Components'

import { ApplicationLink } from './ApplicationCells'

import type { KanbanCardRow, TransportRequestKanbanItem } from '@/Containers/TransportationSection/Components'

const addresses = (list: string[] | null | undefined): string => (list ?? []).filter(Boolean).join('; ')

/**
 * Рядки картки канбану заявки під «Ід» (`SPEC-021` §8.3; легасі
 * `ApplicationKanbanMode.jsx:107-138`): «Назва», «Клієнт» (посилання), «Тип
 * авто», країни й адреси. Порожнє — «-», як у легасі.
 */
export const applicationKanbanRows = (item: TransportRequestKanbanItem): KanbanCardRow[] => [
    { label: 'Назва', value: item.title ? <Typography.Text ellipsis>{item.title}</Typography.Text> : '-' },
    { label: 'Клієнт', value: item.client ? <ApplicationLink kind="client" record={item.client} /> : '-' },
    { label: 'Тип авто', value: titlesOf(item.typesCars) || '-' },
    { label: 'Країни завантаження', value: titlesOf(item.loadingCountries) || '-' },
    { label: 'Адр. завант.', value: addresses(item.loadingAddresses) || '-' },
    { label: 'Країна розвант.', value: titlesOf(item.unloadingCountries) || '-' },
    { label: 'Адр. розвант.', value: addresses(item.unloadingAddresses) || '-' },
]
